var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 22"
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "top",
    x1: 0,
    x2: 27,
    y1: 2,
    y2: 2,
    vectorEffect: "non-scaling-stroke"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "mid",
    x1: 0,
    x2: 27,
    y1: 11,
    y2: 11,
    vectorEffect: "non-scaling-stroke"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "bot",
    x1: 14.3,
    x2: 27,
    y1: 20,
    y2: 20,
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgHamburger;